import React from 'react';
import { Create, SimpleForm, TextInput, NumberInput, required, ImageInput, ImageField } from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

const initialValues = {
    designCode: '',
    designName: '',
    cartonCapacity: undefined,
    photograph: '',
};

export const ProductGroupCreate = (props: any) => (
    <React.Fragment>
        <Create title="Create Product Group" {...props}>
            <SimpleForm
                warnWhenUnsavedChanges
                redirect="list"
                toolbar={<FormToolbar {...props} />}
                initialValues={initialValues}
                variant="outlined"
            >
                <TextInput source="designCode" label="Design Code" fullWidth validate={[required()]} />
                <TextInput source="designName" label="Design Name" fullWidth validate={[required()]} />
                <NumberInput source="cartonCapacity" label="Carton Capacity" fullWidth />
                
                
                
                <ImageInput fullWidth={true} source="imageurl" label="Photograph" accept="image/*">
                    <ImageField source="src" title="title" />
                </ImageInput>
                
            </SimpleForm>
        </Create>
    </React.Fragment>
);
